const fallbackMinimumAge = 25;

export { fallbackMinimumAge };
